import React from "react";

import { Route, Routes } from "react-router-dom";

import ContentLayout from "Components/ContentLayout";

import AddEnvironmentDomain from "./containers/AddEnvironmentDomain";
import EnvironmentDomainsSettings from "./containers/EnvironmentDomainsSettings";
import EnvironmentDomainView from "./containers/EnvironmentDomainView";

const EnvrionmentSettingsDomainsRoutes = () => (
  <ContentLayout>
    <Routes>
      <Route path="-/add" element={<AddEnvironmentDomain />} />
      <Route path=":environmentDomainId" element={<EnvironmentDomainView />} />
      <Route path="" element={<EnvironmentDomainsSettings />} />
    </Routes>
  </ContentLayout>
);
export default EnvrionmentSettingsDomainsRoutes;
